import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const saveFile = async ({ id, documents, pathname }) => {
	const { data } = await axios.post(`${API}/client/files/upload_file`, {
		id,
		files: documents,
		value: pathname,
	});

	return data;
};

export const deleteFile = async (document) => {
	const { data } = await axios.post(`${API}/client/files/delete_file`, document);

	return data;
};

export const downloadPdf = async (params) => {
	const { data } = await axios.get(`${API}/client/application_orders/download-pdf`, {
		params: params,
		responseType: "blob",
	});
	return data;
};

export const getPreview = async (params) => {
	const { data } = await axios.get(`${API}/client/application_orders/preview`, {
		params: params,
	});
	return data;
};
